"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trommel = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Verpackung_1 = require("./Verpackung");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * The class `Trommel` is a Value Object representing an igus Trommel article.
 */
class Trommel extends Verpackung_1.Verpackung {
    constructor() {
        super(...arguments);
        this.className = 'Trommel';
    }
    get kerndurchmesser() {
        return echain_shared_quantities_1.Q.optional(this.model.Kerndurchmesser);
    }
    set kerndurchmesser(value) {
        this.model.Kerndurchmesser = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get innenbreite() {
        return echain_shared_quantities_1.Q.optional(this.model.Innenbreite);
    }
    set innenbreite(value) {
        this.model.Innenbreite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get flanschdurchmesser() {
        return echain_shared_quantities_1.Q.optional(this.model.Flanschdurchmesser);
    }
    set flanschdurchmesser(value) {
        this.model.Flanschdurchmesser = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get flanschstaerke() {
        return echain_shared_quantities_1.Q.optional(this.model.Flanschstaerke);
    }
    set flanschstaerke(value) {
        this.model.Flanschstaerke = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get trommelbelastungMax() {
        return echain_shared_quantities_1.Q.optional(this.model.TrommelbelastungMax);
    }
    set trommelbelastungMax(value) {
        this.model.TrommelbelastungMax = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get trommelkern() {
        return this.model.Trommelkern;
    }
    set trommelkern(value) {
        this.model.Trommelkern = value;
    }
    get waermebehandelt() {
        return this.model.Waermebehandelt;
    }
    set waermebehandelt(value) {
        this.model.Waermebehandelt = value;
    }
    static fromScratch() {
        return new Trommel({
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            Typ: echain_shared_articles_1.VerpackungType.trommel,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Trommel.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const trommel = Trommel.fromJson(args, cloneStrategy);
        trommel.artNrExists = true;
        return trommel;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Trommel.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const trommel = Trommel.fromJson(args, cloneStrategy);
        trommel.artNrExists = false;
        return trommel;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const trommel = Trommel.fromScratch();
        trommel.fromJson(args, cloneStrategy);
        return trommel;
    }
    static fromModel(model) {
        const trommel = Trommel.fromScratch();
        Object.assign(trommel.model, model);
        Object.assign(model, trommel.model);
        trommel.model = model;
        return trommel;
    }
    clone() {
        return this._clone(Trommel.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    /**
     * Returns the maximal length of a Verpackung or undefined if the maximal length couldn't be
     * calculated.
     */
    getMaxLength() {
        let maxLength;
        if (this.flanschdurchmesser) {
            maxLength = this.flanschdurchmesser.clone();
        }
        return maxLength;
    }
    /**
     * Returns the volume of a Verpackung or undefined if the volume couldn't be calculated.
     */
    getVolume() {
        if (this.flanschdurchmesser && this.innenbreite && this.flanschstaerke) {
            const flanschRadius_m = this.flanschdurchmesser.m / 2;
            const flanschArea_m_2 = Math.PI * flanschRadius_m * flanschRadius_m;
            const flanschHeight_m = this.innenbreite.m + 2 * this.flanschstaerke.m;
            const flanschVolume_m_3 = flanschArea_m_2 * flanschHeight_m;
            return echain_shared_quantities_1.Volume.m_3(flanschVolume_m_3);
        }
        return undefined;
    }
}
exports.Trommel = Trommel;
//# sourceMappingURL=Trommel.js.map